<template>
    <a :href="quiz.link" :class="{ 'practice-menu-item_active': isActive() }" class="practice-menu-item">
        <flex-container>
            <span class="practice-menu-item__icon" v-html="getIcon()"></span>
            <div>
                <p class="practice-menu-item__name">
                    {{ `${quizzes.indexOf(quiz) + 1}. ${quiz.is_name_enabled ? quiz.name : t("quizzes.quizz")}` }}
                </p>
                <flex-container v-if="!isBlocked" class="mt-5">
                    <div v-if="quiz.attempt" class="practice-menu-item__status" v-html="getHTMLStatus()"></div>
                    <PracticeTimerIcon v-if="quiz.options.timer_duration || quizIncludesQuestionWithTimer()" />
                </flex-container>
            </div>
        </flex-container>
    </a>
</template>

<script>
import FlexContainer from "@components/Containers/FlexContainer.vue"
import PracticeTimerIcon from "@components/Practice/common/timer/PracticeTimerIcon.vue"

import { QuizQuestionTypeAdapter } from "@components/Practice/PracticeQuestions/_types"
import { getPracticeHTMLStatus } from "@components/Practice/shared/practice-status"

export default {
    components: { PracticeTimerIcon, FlexContainer },
    props: {
        quizzes: {
            type: Array,
            default: () => []
        },
        lesson: {
            type: Object,
            default: null
        },
        quiz: {
            type: Object,
            default: () => {}
        }
    },
    name: "PracticeMenuItem",
    data() {
        return {
            quizId: 0
        }
    },
    created() {
        const url = new URL(window.location)
        this.quizId = parseInt(url.pathname.split("/").pop())
    },
    methods: {
        quizIncludesQuestionWithTimer() {
            if (!this.quiz) {
                return false
            }
            return !!this.quiz.questions.find(q => q.timer)
        },
        getHTMLStatus() {
            if (!this.quiz.attempt) {
                return `<span class="status status_"></span>`
            }
            return getPracticeHTMLStatus.call(this, this.quiz.attempt.status_id)
        },
        isActive() {
            return this.quiz.id === this.quizId
        },
        getIcon() {
            return QuizQuestionTypeAdapter[this.quiz.type || ""]?.icon || QuizQuestionTypeAdapter["default"].icon
        }
    },
    computed: {
        isBlocked() {
            return false
            /* return (
                this.practice &&
                (this.practice.is_blocked ||
                    !this.practice.courseAccess.is_course_subscribed ||
                    !this.practice.courseAccess.is_course_available ||
                    this.practice.courseAccess.is_course_blocked)
            )*/
        }
    }
}
</script>

<style scoped lang="sass">
.practice-menu-item
    padding: 7px 10px 7px 10px
    cursor: pointer
    border-radius: 7px
    transition: .2s
    margin-right: 12px
    display: block
    &::v-deep
        .status
            margin-right: 5px
            font-size: 13px
            font-weight: 500
            line-height: 17px
            &_green
                color: #15A06E
            &_red
                color: #DD4141
            &_yellow
                color: #E9AF1B
            &_gray
                color: #8797c8
    &:hover
        background: #FBFCFF
    &_active
        background: #F2F7FF !important
    &__name
        font-size: 13px
        line-height: 17px
        margin-top: 3px
        color: #52565C
    &__icon
        margin-right: 8px
        &::v-deep
            svg
                width: 24px
                height: 24px
</style>
